import { useState, useEffect } from "react";

import { Row, Col, Card, Button, Avatar, message, Form, Modal } from "antd";

import BgProfile from "../assets/cms/profile-background-picture.jpg";
import { Input, Select } from "antd";
import { useHistory, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

function ClientProfile() {
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const { id } = useParams();

  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [clientName, setClientName] = useState();
  const [loadingData, setLoadingData] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Client updated successfully",
    });

    history.push("/clients");
  };
  const successDelete = () => {
    messageApi.open({
      type: "success",
      content: "Client deleted successfully",
    });

    history.push("/clients");
  };
  const error = () => {
    messageApi.open({
      type: "error",
      content: "Something went wrong. Please try again later.",
    });
  };

  const deleteClient = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + `clients/deleteClient?clientId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setIsModalOpen(false);
      successDelete();
      history.push("/clients");
    } catch (error) {
      setIsModalOpen(false);
      console.log(error);
      error();
    }
  };

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const getClient = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingData(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `clients/getClient?clientId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);

      setClientName(response.data.name);

      setLoadingData(false);
    } catch (error) {
      console.log(error);
    }
  };

  const updateClient = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");
    if (clientName) {
      try {
        const response = await axios.put(
          process.env.REACT_APP_API_URL + `clients/updateClient?clientId=${id}`,
          {
            id: id,
            name: clientName,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response);
        success();
      } catch (e) {
        console.log(e);
        error(e.response.data.reason);
      }
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getClient();
    // getLocations();
  }, []);

  return (
    <>
      {contextHolder}

      <div
        className="profile-nav-bg"
        style={{ backgroundImage: "url(" + BgProfile + ")" }}
      ></div>

      {loadingData ? (
        <Spinner />
      ) : (
        <>
          <Card
            className="card-profile-head"
            bodyStyle={{ display: "none" }}
            title={
              <Row justify="space-between" align="middle" gutter={[24, 0]}>
                <Col span={24} md={12} className="col-info">
                  <Avatar.Group>
                    {/*<Avatar size={74} shape="square" src={profilavatar} />*/}

                    <div className="avatar-info">
                      <h4 className="font-semibold m-0">{clientName}</h4>
                    </div>
                  </Avatar.Group>
                </Col>
                <Col
                  span={24}
                  md={12}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <h1>{clientName}</h1>
                </Col>
              </Row>
            }
          ></Card>

          <Card
            bordered={false}
            className="header-solid mb-24"
            title={
              <>
                <h6 className="font-semibold">Edit Client</h6>
                <p>Edit client information below</p>
              </>
            }
          >
            <Row
              style={{
                marginLeft: "20px",
                marginRight: "20px",
              }}
            >
              <Form
                {...formItemLayout}
                form={form}
                name="register"
                onFinish={onFinish}
                style={{
                  width: "80%",
                }}
                scrollToFirstError
              >
                <Form.Item
                  name="clientName"
                  label="Client name"
                  initialValue={clientName}
                  tooltip="Please provide a client name"
                  rules={[
                    {
                      required: true,
                      message: "Please input the client name!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    value={clientName}
                    onChange={(e) => setClientName(e.target.value)}
                  />
                </Form.Item>

                <Form.Item {...tailFormItemLayout}>
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    type="secondary"
                    className="tag-primary"
                    htmlType="submit"
                    onClick={() => updateClient()}
                  >
                    Update Client
                  </Button>

                  {/*TODO Add delete if needed*/}
                  {/*<Button*/}
                  {/*  style={{ margin: "10px", marginLeft: "0px" }}*/}
                  {/*  onClick={() => showModal()}*/}
                  {/*  type="danger"*/}
                  {/*>*/}
                  {/*  DELETE Company*/}
                  {/*</Button>*/}
                  {/*<Modal*/}
                  {/*  title="Warning"*/}
                  {/*  open={isModalOpen}*/}
                  {/*  okText="Delete"*/}
                  {/*  okType="danger"*/}
                  {/*  onOk={deleteClient}*/}
                  {/*  onCancel={handleCancel}*/}
                  {/*>*/}
                  {/*  <p>Are you sure you want do delete this client?</p>*/}
                  {/*</Modal>*/}
                </Form.Item>
              </Form>
            </Row>
          </Card>
        </>
      )}
    </>
  );
}

export default ClientProfile;
